import React from 'react'
import { withRouter, Route } from 'react-router-dom'
import url from 'url'
import querystring from 'query-string'
import isequal from 'lodash/isEqual'

import { searchApiParams } from '../../common/constants/searchQueryWhitelist'
import fetchAllRequest from '../../common/utils/fetchAllRequest'
import ga from '../../common/utils/ga'
import { reportPageView } from '../../common/utils/analytics'
import {
  resetAlerts,
  resetErrorPage
} from '../../common/actions/common'
import { setUserSearchResultsViewType } from '../../common/actions/user/preference'
import { parseLocation } from '../../common/utils/urlHelper'
import objectDiff from '../../common/utils/objectDiff'
import { countSearchFor } from '../../common/actions/search/trackSiteSearches'

class PendingNavDataLoader extends React.Component {
  shouldFetchData (previousLocation, newLoaction) {
    const previousParsedLocationQuery = parseLocation({
      pathname: previousLocation.pathname,
      query: querystring.parse(previousLocation.search)
    })
    const newParsedLocationQuery = parseLocation({
      pathname: newLoaction.pathname,
      query: querystring.parse(newLoaction.search)
    })

    return objectDiff(previousParsedLocationQuery, newParsedLocationQuery)
      .some(key => searchApiParams.includes(key))
  }

  componentWillReceiveProps (nextProps) {
    // check whether url has changed
    const navigated = !isequal(nextProps.location, this.props.location)
    const { store, routes } = this.props

    const newLocationQuery = querystring.parse(nextProps.location.search)

    if (navigated) {
      // https://developers.google.com/analytics/devguides/collection/analyticsjs/pages#overriding
      ga('set', 'location', window.location.href)

      // Reset / hide alerts when changing the route after first rendering
      if (store.getState().common.alerts.length) {
        store.dispatch(resetAlerts())
      }

      // Reset (remove) error page if present
      if (store.getState().common.errorPage) {
        store.dispatch(resetErrorPage())
      }

      if (typeof window !== 'undefined' && newLocationQuery.view) {
        store.dispatch(setUserSearchResultsViewType(newLocationQuery.view))
      }

      if (this.shouldFetchData(this.props.location, nextProps.location)) {
        // we have to ge the full location because `matchRoutes` does not return the search query part
        const opts = {
          baseUrl: '',
          isServer: false
        }
        const parsedUrl = url.parse(window.location.href)
        const promiseRequests = fetchAllRequest(store, parsedUrl, routes, opts)
        const currentSite = this.props.store.getState().common.currentSite

        Promise.all(promiseRequests)
          .then(results => {
            reportPageView()
            if (currentSite === 'photodune') countSearchFor(currentSite)
          })
          .catch(() => {
            reportPageView()
          })
      }
    }
  }

  render () {
    const { children, location } = this.props

    return (
      <Route
        location={location}
        render={() => children}
      />
    )
  }
}

export default withRouter(PendingNavDataLoader)



// WEBPACK FOOTER //
// ./client/components/pendingNavDataLoader.js